import { render, staticRenderFns } from "./OTPInput.vue?vue&type=template&id=1c8916d8&"
import script from "./OTPInput.vue?vue&type=script&lang=ts&"
export * from "./OTPInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports